import { render, staticRenderFns } from "./video-item.vue?vue&type=template&id=a6f7d6fc&"
import script from "./video-item.vue?vue&type=script&lang=ts&"
export * from "./video-item.vue?vue&type=script&lang=ts&"
import style0 from "./video-item.vue?vue&type=style&index=0&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports